// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as PmAuthConnectorUtils$OrcaPaymentPage from "../Utilities/PmAuthConnectorUtils.bs.js";

function PlaidSDKIframe(props) {
  var match = React.useState(function () {
        return "";
      });
  var setLinkToken = match[1];
  var linkToken = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsReady = match$1[1];
  var isReady = match$1[0];
  var match$2 = React.useState(function () {
        return [];
      });
  var setPmAuthConnectorsArr = match$2[1];
  var pmAuthConnectorsArr = match$2[0];
  var match$3 = React.useState(function () {
        return "";
      });
  var setPublishableKey = match$3[1];
  var publishableKey = match$3[0];
  var match$4 = React.useState(function () {
        return "";
      });
  var setClientSecret = match$4[1];
  var clientSecret = match$4[0];
  var match$5 = React.useState(function () {
        return "";
      });
  var setSdkAuthorization = match$5[1];
  var sdkAuthorization = match$5[0];
  var match$6 = React.useState(function () {
        return false;
      });
  var setIsForceSync = match$6[1];
  var isForceSync = match$6[0];
  var logger = React.useMemo((function () {
          return HyperLogger$OrcaPaymentPage.make(undefined, {
                      TAG: "Elements",
                      _0: "Payment"
                    }, clientSecret, publishableKey, undefined, undefined);
        }), [
        publishableKey,
        clientSecret
      ]);
  React.useEffect((function () {
          var handleParentWindowMessage = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var metaData = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(json), "metadata");
            var linkToken = Utils$OrcaPaymentPage.getString(metaData, "linkToken", "");
            if (linkToken.length > 0) {
              setLinkToken(function (param) {
                    return linkToken;
                  });
              setPmAuthConnectorsArr(function (param) {
                    return Utils$OrcaPaymentPage.getArray(metaData, "pmAuthConnectorArray").map(Core__JSON.Decode.string);
                  });
              setPublishableKey(function (param) {
                    return Utils$OrcaPaymentPage.getString(metaData, "publishableKey", "");
                  });
              setClientSecret(function (param) {
                    return Utils$OrcaPaymentPage.getString(metaData, "clientSecret", "");
                  });
              setSdkAuthorization(function (param) {
                    return Utils$OrcaPaymentPage.getString(metaData, "sdkAuthorization", "");
                  });
              return setIsForceSync(function (param) {
                          return Utils$OrcaPaymentPage.getBool(metaData, "isForceSync", false);
                        });
            }
            
          };
          window.addEventListener("message", handleParentWindowMessage);
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          return (function () {
                    window.removeEventListener("message", handleParentWindowMessage);
                  });
        }), []);
  React.useEffect((function () {
          PmAuthConnectorUtils$OrcaPaymentPage.mountAllRequriedAuthConnectorScripts(pmAuthConnectorsArr, (function (authConnector) {
                  if (PmAuthConnectorUtils$OrcaPaymentPage.pmAuthNameToTypeMapper(authConnector) === "PLAID") {
                    return setIsReady(function (param) {
                                return true;
                              });
                  }
                  
                }), logger);
        }), [pmAuthConnectorsArr]);
  var callbackOnSuccessOfPlaidPaymentsFlow = async function () {
    try {
      var json = await PaymentHelpers$OrcaPaymentPage.retrievePaymentIntent(clientSecret, undefined, publishableKey, logger, "", true, Caml_option.some(sdkAuthorization));
      var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      var status = Utils$OrcaPaymentPage.getString(dict, "status", "");
      var return_url = Utils$OrcaPaymentPage.getString(dict, "return_url", "");
      switch (status) {
        case "failed" :
            Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
            break;
        case "processing" :
        case "requires_customer_action" :
        case "succeeded" :
            Utils$OrcaPaymentPage.postSubmitResponse(json, return_url);
            break;
        default:
          Utils$OrcaPaymentPage.postFailedSubmitResponse("sync_payment_failed", "Payment is processing. Try again later!");
      }
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                    "fullscreen",
                    false
                  ]]);
    }
    catch (exn){
      return logger.setLogError("Retrieve failed via Plaid", "PLAID_SDK", undefined, undefined, undefined, undefined, "PLAID");
    }
  };
  var initializePlaid = function () {
    window.Plaid.create({
            token: linkToken,
            onSuccess: (function (publicToken, param) {
                Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                      [
                        "isPlaid",
                        true
                      ],
                      [
                        "publicToken",
                        publicToken
                      ]
                    ]);
                if (isForceSync) {
                  callbackOnSuccessOfPlaidPaymentsFlow();
                  return ;
                }
                
              }),
            onLoad: (function () {
                logger.setLogInfo("Plaid SDK Loaded", "PLAID_SDK", undefined, undefined, undefined, undefined, undefined);
              }),
            onExit: (function (param) {
                if (isForceSync) {
                  callbackOnSuccessOfPlaidPaymentsFlow();
                  return ;
                } else {
                  return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                              [
                                "fullscreen",
                                false
                              ],
                              [
                                "isPlaid",
                                true
                              ],
                              [
                                "isExited",
                                true
                              ],
                              [
                                "publicToken",
                                ""
                              ]
                            ]);
                }
              })
          }).open();
  };
  React.useEffect((function () {
          if (isReady && linkToken.length > 0) {
            initializePlaid();
          }
          
        }), [
        isReady,
        linkToken,
        logger
      ]);
  return React.createElement("div", {
              className: "PlaidIframe h-screen w-screen bg-black/40 backdrop-blur-sm m-auto",
              style: {
                opacity: "100",
                transition: "opacity .35s ease .1s,background-color 600ms linear"
              }
            });
}

var make = PlaidSDKIframe;

export {
  make ,
}
/* react Not a pure module */
